import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./root";
import { AccountView } from "../features/account";

export const accountRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/account",
  component: AccountView,
});
